import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { signInWithEmailAndPassword, signInWithCustomToken } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { auth, functions } from '../firebase.js';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const isSignUp = Boolean(code);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      if (isSignUp) {
        const signUpWithAccessCode = httpsCallable(functions, 'signUpWithAccessCode');
        const result = await signUpWithAccessCode({ code, email, password });
        await signInWithCustomToken(auth, result.data.customToken);
        navigate('/account');
      } else {
        await signInWithEmailAndPassword(auth, email, password);
        navigate('/');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="center-page">
      <div className="panel" style={{ maxWidth: 400 }}>
        <Form onSubmit={handleSubmit}>
          <h2>{isSignUp ? 'Create account' : 'Login'}</h2>
          {isSignUp && <Alert variant="success">✓ Invite accepted</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} />
          </Form.Group>
          <Button type="submit" disabled={submitting}>
            {isSignUp ? 'Create account' : 'Login'}
          </Button>
        </Form>
      </div>
    </div>
  );
}
